module.exports = __webpack_public_path__ + "img/uber.4f16729a.svg";